import {z} from 'src/lib'
import {OperacionCapitalMarketsFields} from "./fields";
import {
  schemaOperacionCapitalMarkets,
  schemaOperacionCapitalMarketsDetalle,
  shapeSchemaFormOperacionCapitalMarkets
} from "./types";

// TODO: refactor esto para no repetir el mismo schema que se usa en el form
export const schemaFormCapitalMarketsUpdate = z.object({
  [OperacionCapitalMarketsFields.SectorPrivado]: z.boolean().optional(),
  [OperacionCapitalMarketsFields.EmisorPreAprobado]: z.boolean(),
  [OperacionCapitalMarketsFields.Underwriting]: z.boolean().optional(),
  [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting]: z.string().optional(),
  [OperacionCapitalMarketsFields.Limites]: z.union([z.number(), z.string()]).optional().nullable()
}).refine(data => !(data[OperacionCapitalMarketsFields.SuperaLimitesUnderwriting] === 'Si' && !data[OperacionCapitalMarketsFields.Underwriting]), {
  message: "Supera Limites Underwriting requires Underwriting",
  path: [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting],
}).refine(data => !(data[OperacionCapitalMarketsFields.SuperaLimitesUnderwriting] && data[OperacionCapitalMarketsFields.Limites] === undefined), {
  message: "Limites requires SuperaLimitesUnderwriting",
  path: [OperacionCapitalMarketsFields.Limites],
});

export type OperacionCapitalMarketsUpdateDTO = z.infer<typeof schemaFormCapitalMarketsUpdate>


export const schemaCapitalMarketsInsert = z.object({
  [OperacionCapitalMarketsFields.CodPais]: z.number(),
  [OperacionCapitalMarketsFields.EmisorPreAprobado]: z.boolean(),
  [OperacionCapitalMarketsFields.SectorPrivado]: z.boolean().optional(),
  [OperacionCapitalMarketsFields.Underwriting]: z.boolean().optional(),
  [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting]: z.string().optional(),
  [OperacionCapitalMarketsFields.Limites]: z.union([z.number(), z.string()]).optional().nullable(),
  [OperacionCapitalMarketsFields.BitEnvio]: z.boolean(),
  [OperacionCapitalMarketsFields.Detalle]: schemaOperacionCapitalMarketsDetalle
}).refine(data => !(data[OperacionCapitalMarketsFields.SuperaLimitesUnderwriting] === 'Si' && !data[OperacionCapitalMarketsFields.Underwriting]), {
  message: "Supera Limites Underwriting requires Underwriting",
  path: [OperacionCapitalMarketsFields.SuperaLimitesUnderwriting],
}).refine(data => !(data[OperacionCapitalMarketsFields.SuperaLimitesUnderwriting] && data[OperacionCapitalMarketsFields.Limites] === undefined), {
  message: "Limites requires SuperaLimitesUnderwriting",
  path: [OperacionCapitalMarketsFields.Limites],
});

export type OperacionCapitalMarketsInsertDTO = z.infer<typeof schemaCapitalMarketsInsert>

export const schemaOperacionCapitalMarketsView = schemaOperacionCapitalMarkets.omit({[OperacionCapitalMarketsFields.BitEnvio]: true})

export type OperacionCapitalMarketsViewDTO = z.infer<typeof schemaOperacionCapitalMarketsView>